import { render, staticRenderFns } from "./ShowAlert.vue?vue&type=template&id=38731418&scoped=true"
import script from "./ShowAlert.vue?vue&type=script&lang=js"
export * from "./ShowAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38731418",
  null
  
)

export default component.exports